<script>
const initialFiltersState = {
  debts: false,
  expenses: false,
  paid: false,
  unpaid: false,
  pending: false,
  receipt: false,
  waiting_receive_payment: false,
  payment_method: "",
  expense_category: ""
}
export default {
  data: function() {
    return {
      filters: {...initialFiltersState},
      show: false
    };
  },
  mounted() {
    const url = new URL(window.location.href);
    url.searchParams.forEach((v, k) => {
      if (this.$data["filters"][k] !== undefined) {
        if (v === "true") {
          v = true;
        }
        if (v === "false") {
          v = false;
        }
        this.$data["filters"][k] = v;
      }
    });
    this.$emit("filters-updated", this.$data.filters);
  },
  methods: {
    submit() {
      this.$emit("filters-updated", this.$data.filters);
      this.$emit("filters-submitted", this.$data.filters);
      this.show = !this.show;
    },
    clearFilters(){
      this.filters = {...initialFiltersState}
      this.$emit("filters-updated", this.filters);
      this.$emit("filters-submitted", this.filters);
    }
  },
  computed: {
    type: {
      get() {
        if (
          (this.filters.debts && this.filters.expenses) ||
          (!this.filters.debts && !this.filters.expenses)
        ) {
          return "all";
        }

        if (this.filters.debts === true) {
          return "debts";
        }

        if (this.filters.expenses === true) {
          return "expenses";
        }
      },
      set(newValue) {
        switch (newValue) {
          case "all":
            this.filters.expenses = false;
            this.filters.debts = false;
            break;

          case "expenses":
            this.filters.expenses = true;
            this.filters.debts = false;
            break;

          case "debts":
            this.filters.debts = true;
            this.filters.expenses = false;
            break;
        }
      }
    },
    paymentStatus: {
      get() {
        if (
          (this.filters.paid && this.filters.unpaid && this.filters.waiting_receive_payment) ||
          (!this.filters.paid && !this.filters.unpaid && !this.filters.waiting_receive_payment)
        ) {
          return "all";
        }

        if (this.filters.paid === true) {
          return "paid";
        }

        if (this.filters.unpaid === true) {
          return "unpaid";
        }

        if (this.filters.waiting_receive_payment === true) {
          return "waiting_receive_payment";
        }
      },
      set(newValue) {
        switch (newValue) {
          case "all":
            this.filters.paid = false;
            this.filters.unpaid = false;
            this.filters.waiting_receive_payment = false;
            break;

          case "paid":
            this.filters.paid = true;
            this.filters.unpaid = false;
            this.filters.waiting_receive_payment = false;
            break;

          case "unpaid":
            this.filters.unpaid = true;
            this.filters.paid = false;
            this.filters.waiting_receive_payment = false;
            break;

          case "waiting_receive_payment":
            this.filters.unpaid = false;
            this.filters.paid = false;
            this.filters.waiting_receive_payment = true;
            break;
        }
      }
    }
  }
};
</script>
